export default "__VITE_ASSET__C2qXC5lx__"